import { React, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import axios from "axios";


function CasRedirect() {
  const [, setCookie] = useCookies();
  const navigate = useNavigate();

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const ticket = searchParams.get("ticket");
    sendTicketToBackend(ticket);
  }, [window.location.search]);

  const sendTicketToBackend = (ticket) => {
    axios.post("/validate-ticket", { ticket: ticket }).then((res) => {
      const data = res.data;
      //console.log(data);

      // If the ticket is valid, set the cookie and redirect to the homepage
      if (data.success) {
        const expiration = new Date(data.expiration);
        setCookie("auth_token", data.token, { path: "/", expires: expiration });
        //console.log("sucess in casRedirect data.success");
      }
      navigate("/");
    });
  };

  return <div>Redirecting...</div>;
}

export default CasRedirect;
